import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  HostListener,
  NgZone, Renderer2, Inject
} from '@angular/core';
import {BsDropdownConfig} from 'ngx-bootstrap/dropdown';
import {from, fromEvent, throttleTime} from 'rxjs';
import {debounceTime, delay, filter} from 'rxjs/operators';
import {DatePipe} from '@angular/common';
import {isObject, isUndefined} from 'util';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DynamicScriptLoaderService} from '../../../services/dynamic-script-loader.service';
import {GalleryService} from '../../../services/gallery.service';
import {VkService} from '../../../pages/page-vk/vk.service';
import {Chat, IMessengerConnector, Message, MessageUser, ResultChatDetail} from '../../../types/all.type';
import {AllMessengersService} from '../../../pages/page-start/all-messengers.service';
import {AllService} from '../../../services/all.service';
import {log} from '../../../functions';
import {InterfaceService} from '../../../services/interface.service';
import {ModalService} from "../../../services/modal.service";
import {WebrtcService} from "../../../services/webrtc.service";
import {CallService} from "../../../services/call.service";
import {AppService} from "../../../services/app.service";

@Component({
  selector: 'app-chat-detail',
  templateUrl: './chat-detail.component.html',
  styleUrls: ['./chat-detail.component.scss'],
  providers: [{provide: BsDropdownConfig, useValue: {isAnimated: true, autoClose: true}}],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatDetailComponent implements OnInit, OnChanges {
  @ViewChild('wrap') wrap: ElementRef;
  private detectChangesTimeout: NodeJS.Timeout;
  @Input() id: any;
  @Input() initData: any;

  @Input() Service: IMessengerConnector;
  @Input() modalMode = false;
  public arResult: ResultChatDetail | any = {};
  public arPhotos: any = [];
  public arDocs: any = [];
  public isLoaded = false;
  public arOffsets: any = {};
  public arComplete: any = {};
  public arLoads: any = {};
  public _isLoads = false;
  public arSettings: any;
  public isActual = false;
  public currentTimestamp: number = Date.now();
  public isSticky = false;
  checkScrollTimeout: NodeJS.Timeout;
  @ViewChild('scrollable') scrollable: ElementRef;
  @ViewChild('wrapFixedInfo') wrapFixedInfo: ElementRef;

  constructor(
    public appService: AppService,
    public webrtcService: WebrtcService,
    public modalService: ModalService,
    public allService: AllService,
    public allMessengersService: AllMessengersService,
    public galleryService: GalleryService,
    public dynamicScriptLoaderService: DynamicScriptLoaderService,
    public bsModalRef: BsModalRef,
    public notifierWrapService: NotifierWrapService,
    public cd: ChangeDetectorRef,
    private datepipe: DatePipe,
    private zone: NgZone,
    public interfaceService: InterfaceService,
    private renderer: Renderer2,
    public callService: CallService
  ) {
  }

  ngOnInit(): void {
    log(this.initData);
    this.cd.detach();
    if (this.initData) {
      this.arResult.user = this.initData.user || {};
      if (!this.arResult.user.name) {
        this.arResult.user.name = this.initData.name;
      }
      if (!this.arResult.user.last_seen) {
        this.arResult.user.last_seen = this.initData.last_seen;
      }
      if (!this.arResult.user?.username || this.initData.from_user?.username) {
        this.arResult.user.username = this.initData?.username || this.initData.from_user?.username;
      }
      if (!this.initData.chat) {
        this.arResult.chat = {};
        this.arResult.chat.members = this.initData.members;
        this.arResult.chat.title = this.initData.title;
        this.arResult.chat.description = this.initData.description;
        this.arResult.chat.phone_number = this.initData.phone_number;
        this.arResult.chat.avatar = this.initData.avatar;
        this.arResult.chat.id = this.initData.id;
        this.arResult.chat.avatar_orig = this.initData.avatar_orig;
      } else {
        this.arResult.chat = this.initData.chat;
      }
    }
    this.zone.runOutsideAngular(() => {
      fromEvent(this.scrollable.nativeElement, 'scroll')
        .pipe(
          debounceTime(100)
          // Is elementId scrolled for more than 50 from top?
          // distinctUntilChanged(),
        )
        .subscribe((e: Event) => {
          // console.log(e);
          this.isSticky = (e.srcElement as Element).scrollTop > 150;
          if (this.isSticky && (this.isLoaded || this.initData)) {
            const offsetHeight = this.wrapFixedInfo?.nativeElement?.offsetHeight;
            this.renderer.setStyle(this.wrapFixedInfo.nativeElement, "height", `${offsetHeight}px`);
          }
          this.cd.detectChanges();
        });
    });
    this.detectChanges();
  }

  addTitleList(arMesages: Message[]) {
    if (isObject(arMesages)) {
      for (let i = 0; i < arMesages.length; i++) {
        if (arMesages[i]?.attachments?.length > 0) {
          arMesages[i].attachment = arMesages[i].attachments[0];
        }
        arMesages[i].date = arMesages[i].date || arMesages[i].attachment?.date;
        arMesages[i].date_format = this.datepipe.transform(arMesages[i].date, 'y MMMM');
        arMesages[i].show_title =
          i === 0 || (arMesages[i - 1] && arMesages[i - 1].date_format !== arMesages[i].date_format);
      }
    }
  }

  set notify(val) {
    this.Service.setNotify({
      peer: this.id,
      mute_until: val ? 0 : Math.round((this.currentTimestamp + 60 * 60 * 24 * 365 * 5 * 1000) / 1000),
      type: this.Service.type
    }).subscribe(
      (result: any) => {
        if (val) {
          this.notifierWrapService.notify('success', 'Уведомления включены');
        } else {
          this.notifierWrapService.notify('info', 'Уведомления отключены');
        }
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }

  get notify() {
    return this.currentTimestamp > this.arSettings.mute_until * 1000;
  }

  getNotifySettings(): void {
    if (this.Service.type !== 'all') {
      this.Service.getNotify(this.id, this.Service.openChat).subscribe(
        (result: any) => {
          this.arSettings = result;
        },
        (error) => {
        }
      );
    }
  }

  init() {
    if (this.id) {
      const chatsLocal = this.Service.getVarLocal('chat-detail', {});
      this.isLoads = true;
      this.getNotifySettings();
      if (typeof chatsLocal[this.id] === 'undefined' || chatsLocal[this.id]?.length === 0) {
        this.isLoaded = false;
        this.isActual = false;
        this.loadChatInfo(chatsLocal);
      } else {
        this.arResult = chatsLocal[this.id];
        this.isLoaded = true;
        this.cd.detectChanges();
        this.loadChatInfo(chatsLocal, 1000);
      }

      /*
                  this.Service.getChatSearch(this.id, 'photo').subscribe((result: any) => {
                      this.arPhotos = result;
                    },
                    error => {
                      this.interfaceService.errorHandling(error);
                    });
                  this.Service.getChatSearch(this.id, 'document').subscribe((result: any) => {
                      this.arDocs = result;
                    },
                    error => {
                      this.interfaceService.errorHandling(error);
                    });

                   */
    }
  }

  loadChatInfo(chatsLocal: any, timeout = 0) {
    setTimeout(() => {
      this.Service.getDetailInfo(this.id).subscribe(
        (result: ResultChatDetail) => {
          this.addTitleList(result.voice_note);
          this.addTitleList(result.audio);
          this.addTitleList(result.url);
          this.addTitleList(result.document);
          this.addTitleList(result.video);
          this.addTitleList(result.photo);

          this.arResult = result;
          chatsLocal[this.id] = this.arResult;
          this.isLoaded = true;
          this.isActual = true;
          this.isLoads = false;
          this.Service.setVarLocal('chat-detail', chatsLocal);
        },
        (error) => {
          this.isLoads = false;
          this.interfaceService.errorHandling(error);
        }
      );
    }, timeout);
  }

  ngOnChanges() {
    this.init();
  }

  lazyLoad(vizible, filter: string): void {
    this.arOffsets[filter] = isUndefined(this.arOffsets[filter]) ? 15 : this.arOffsets[filter];
    this.arComplete[filter] = isUndefined(this.arComplete[filter]) ? false : this.arComplete[filter];

    if (!vizible || this.arComplete[filter]) return;
    this.arLoads[filter] = true;
    this.isLoads = true;

    this.arOffsets[filter] += 15;
    this.Service.getChatSearch(this.id, filter, '', this.arOffsets[filter], 15).subscribe(
      (result: any) => {
        this.addTitleList(result.result);
        this.arLoads[filter] = false;
        if (result.result.length === 0) {
          this.arComplete[filter] = true;
        } else {
          for (let i = 0; i < result.result.length; i++) {
            this.arResult[filter].push(result.result[i]);
          }
        }
        this.isLoads = false;
      },
      (error) => {
        this.isLoads = false;
        this.interfaceService.errorHandling(error);
      }
    );
  }

  getFileSrc(attachment: any) {
    if (!attachment.file_uri) {
      this.Service.getFileSrc(attachment);
      this.detectChanges();
    }
  }

  getAllSrc(attachment) {
    if (!attachment.file_uri) {
      this.Service.getThumbSrc(attachment);
      this.Service.getFileSrc(attachment);
      this.detectChanges();
    }
    this.galleryService.addToGallery(attachment);
  }

  onClose() {
    this.interfaceService.showDetail$.next(false);
  }

  loadImageAttachmentError(event, attachment) {
    attachment.thumb.file_uri = undefined;
    attachment.thumb.file_uri_error = true;
    this.cd.detectChanges();
  }

  videoIframeInit(attachment) {
    if (this.Service instanceof VkService) {
      this.Service.getVideoSrc$(attachment).subscribe((res) => {
        attachment = res;
        this.cd.detectChanges();
      });
    }
  }

  getItems(key): Message[] {
    return this.arResult[key];
  }

  detectChanges() {
    clearTimeout(this.detectChangesTimeout);
    this.detectChangesTimeout = setTimeout(() => {
      this.cd.detectChanges();
    }, 100);
  }

  openChat(id: any) {
    this.bsModalRef.hide();
    this.appService.openChat(id, this.Service.type);
  }

  get isLoads(): boolean {
    return this._isLoads;
  }

  set isLoads(val) {
    this._isLoads = val;
    this.cd.detectChanges();
  }

  get showUserNamePrefix(): boolean {
    return this.Service.arProfile?.username?.indexOf('@') != -1;
  }
}
